<template>
<v-dialog v-model="show" max-width="600">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on"></slot>
  </template>
  <v-card :loading="loading" :disabled="loading">
    <CardTitle title="CCRS Integrator Parser"></CardTitle>
    <v-alert type="error" v-if="error">{{error_message}}</v-alert>
    <v-card-text>
      <v-radio-group v-model="type" row>
        <v-radio label="Link" :value="1"></v-radio>
        <v-radio label="Json file" :value="2"></v-radio>
        <v-radio label="text" :value="3"></v-radio>
      </v-radio-group>
      <template v-if="type === 1">
        <v-text-field v-model="link" label="Enter Link"></v-text-field>
      </template>
      <template v-else-if="type === 2">
        <v-file-input v-model="file" label="pick .json file"></v-file-input>
      </template>
      <template v-else>
        <v-textarea v-model="text" label="Paste JSON Text"></v-textarea>
      </template>
    </v-card-text>
    <CardActions @close="show = false" @submit="parse"></CardActions>
  </v-card>
</v-dialog>
</template>

<script>
import {nanoid} from 'nanoid'
import axios from 'axios';
export default {
    name: "IntegratorParser",
    components: {},
    data: () => ({
      show: false,
      loading: false,
      error: false,
      error_message: "",
      type: 3,
      file: null,
      link: null,
      text: null,
    }),
    props: {
      order_id: {
        required: false,
      },
      preloaded_manifest: {
        required: false,
      }
    },
    mounted(){
      if(this.preloaded_manifest){
        this.manifestToSamples(this.preloaded_manifest);
      }
    },
    methods: {
      async parse(){
        this.error = false;
        this.loading = true;
        let parse = false;
        if(this.type === 1){
          parse = await this.getUrlManifest()
        }else if(this.type === 2){
          parse = await this.getFileManifest()
        }else if(this.type === 3){
          parse = await this.getTextManifest()
        }
        if(parse){
          this.manifestToSamples(parse);
        }
        this.loading = false;
      },
      async getTextManifest(){
        try{
          let text = await this.text;
          return JSON.parse(text)
        }catch(e){
          this.error = true;
          this.error_message = "Text might not be in the correct format or the full text wasn't copied."
        }
        return false;
      },
      async getFileManifest(){
        try{
          let text = await this.file.text();
          return JSON.parse(text)
        }catch(e){
          this.error = true;
          this.error_message = "File might not be in the right format. You cant try to copy the files contents and paste it in the text option or ask the dev team for help."
        }
        return false;
      },
      async getUrlManifest(){
          try{
            let query = await axios.get(this.link);
            return query.data;
          }catch(e){
            this.error = true;
            this.error_message = "Failed to get data from url, try loading the url in a new tab and either copy the text and paste it into the text option or ctrl+s to save the json and input it as a file."
          }
          return false;
      },
      manifestToSamples(manifest){
        const baseSample = {
          id: null,
          customer_id: null,
          order_id: null,
          customer_name_id: null,
          manifest_id: null,
          is_rnd: false,
          qa: null,
          lot: null,
          unit_uuid: this.$store.$db().model('units').query().where('name', 'g').first().uuid,
          weight: 0,
          serving_weight: null,
          created_by: this.$store.getters.id,
          updated_by: this.$store.getters.id,
          notes: [],
          sample_flags: [],
          meta_data: {
            package_weight: null,
            collection_date: manifest.collection_date ? this.$moment(manifest.collection_date).format('YYYY-MM-DD') : null,
          }
        }
        let samples = manifest.inventory_transfer_items.map(item => {
          let nameItems = [];
          if(item.strain_name) nameItems.push(item.strain_name);
          if(item.variety_name) nameItems.push(item.variety_name);
          if(item.product_name) nameItems.push(item.product_name);
          console.log(manifest, 'MANIFEST LOADED IN PARSER' +
              '')
          const sample =  {
            ...baseSample,
            id: 'PENDING-'+nanoid(5),
            order_id: this.order_id,
            manifest_id: manifest.transfer_id,
            lot: item.sample_source_id ? item.sample_source_id : item.inventory_id,
            qa: item.inventory_id,
            // lot: item.sample_source_id ? item.sample_source_id : null,
            // qa: item.inventory_id,
            serving_weight: null,
            name: item.product_name ? item.product_name : item.variety_name ? item.variety_name : item.strain_name,
            name_items: nameItems,
            legal_type: this.buildLegalType(item),
            is_rnd: !(!item.sample_type || (item.sample_type && item.sample_type.toLowerCase() === "qa")),
            meta_data: {
              ...baseSample.meta_data,
              collection_date: item.sample_collection_date ? this.$moment(item.sample_collection_date).format('YYYY-MM-DD') : baseSample.meta_data.collection_date,
              strain_name: item.strain_name ? item.strain_name : null,
            }
          }
          if('is_medical' in item && parseInt(item.is_medical)){
            const flag = this.$store.$db().model('sampleFlagTypes').query().where('name', 'Medical').first();
            sample.sample_flags =  [{
              uuid: null,
              sample_flag_type_uuid: flag.uuid,
              created_by: this.$store.getters.id,
              updated_by: this.$store.getters.id,
              type: flag,
            }];

            sample.sample_tests = [this.$store.$db().model('sampleTestTypes').query().where('name', 'HM').first().uuid]
          }

          return sample
        })
        this.$emit("set_manifest_id", manifest.transfer_id);
        this.$emit("mapped_samples", samples)
        this.$emit('set_customer', {customer_name: manifest.from_license_name, customer_license: manifest.from_license_number})
        this.show = false;
      },
      buildLegalType(inventory){
        let category = inventory.inventory_category;
        let type = inventory.inventory_type;
        if(!category) category = 'MissingCategory';
        if(!type) type = 'MissingType';

        if(category.includes('_')) category = category.split('_').map((item) => this.capitolizeWord(item)).join('');
        if(category.includes(' ')) category = category.split(' ').map((item) => this.capitolizeWord(item)).join('');

        if(type.includes('_')) type = type.split('_').map((item) => this.capitolizeWord(item)).join('');
        if(type.includes(' ')) type = type.split(' ').map((item) => this.capitolizeWord(item)).join('');

        return `${category}:${type}`;
      },
      capitolizeWord(word){
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    }
}
</script>

<style scoped>

</style>
